<!-- ── PROPERTY & FINANCING ── -->
<app-ip-shell [activeStep]="2">

  <!-- ── FORM COLUMN ── -->
  <div formCol>
    <div class="ip-form-head">
      <div class="ip-form-head__step-meta">Step 02 &middot; Property &amp; Financing</div>
      <h1 class="ip-form-head__title">Property value and financing structure</h1>
      <p class="ip-form-head__subtitle">
        Set up your investment structure and mortgage preferences.
      </p>
    </div>

    <div class="ip-form-body">

      <!-- Property Value -->
      <div class="ip-field">
        <div class="ip-field__head">
          <label class="ip-field__label" for="propertyValue">Property value</label>
          <span class="ip-hint"><span class="ip-hint__dot"></span>UK market average: £280k</span>
        </div>
        <div class="ip-input" [class.ip-input--error]="PropertyValue==''">
          <span class="ip-input__prefix">£</span>
          <input
            type="text"
            id="propertyValue"
            class="ip-input__field"
            autocomplete="off"
            placeholder="e.g. 250,000"
            [(ngModel)]="PropertyValue"
            (keyup)="PropertyValue=validation.amountWithComma(PropertyValue)"
            (keypress)="validation.numberOnly($event)">
        </div>
      </div>

      <!-- Mortgage toggle -->
      <div class="ip-field">
        <label class="ip-field__label">Will you need a mortgage?</label>
        <div class="ip-segmented">
          <button class="ip-segmented__option" [class.is-active]="optmortgage=='1'" (click)="optmortgage='1'" type="button">Yes, with a mortgage</button>
          <button class="ip-segmented__option" [class.is-active]="optmortgage=='0'" (click)="optmortgage='0'" type="button">No, all-cash purchase</button>
        </div>
      </div>

      <!-- Cash purchase notice -->
      <div class="ip-cash-notice" [class.is-hidden]="optmortgage!='0'">
        <div class="ip-cash-notice__icon">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"></polyline></svg>
        </div>
        <div>
          <span class="ip-cash-notice__title">All-cash purchase</span>
          <span class="ip-cash-notice__sub">Your full property value is the deposit. We'll skip mortgage details and move on.</span>
        </div>
      </div>

      <!-- Mortgage details group -->
      <div class="ip-conditional-group" [class.is-hidden]="optmortgage=='0'">
        <div class="ip-conditional-group__head">Mortgage details</div>

        <!-- LTV chips -->
        <div class="ip-field">
          <div class="ip-field__head">
            <label class="ip-field__label">Loan to Value (LTV)</label>
            <span class="ip-hint"><span class="ip-hint__dot"></span>Residential typically 75–90%</span>
          </div>
          <div class="ip-chip-row">
            <button class="ip-chip" [class.is-active]="loanAmount=='50'" (click)="loanAmount='50'" type="button">50%</button>
            <button class="ip-chip" [class.is-active]="loanAmount=='55'" (click)="loanAmount='55'" type="button">55%</button>
            <button class="ip-chip" [class.is-active]="loanAmount=='60'" (click)="loanAmount='60'" type="button">60%</button>
            <button class="ip-chip" [class.is-active]="loanAmount=='65'" (click)="loanAmount='65'" type="button">65%</button>
            <button class="ip-chip" [class.is-active]="loanAmount=='70'" (click)="loanAmount='70'" type="button">70%</button>
            <button class="ip-chip" [class.is-active]="loanAmount=='75'" (click)="loanAmount='75'" type="button">75%</button>
            <button class="ip-chip" [class.is-active]="loanAmount=='80'" (click)="loanAmount='80'" type="button">80%</button>
          </div>
        </div>

        <!-- Interest Rate -->
        <div class="ip-field">
          <div class="ip-field__head">
            <label class="ip-field__label" for="mortgageInterestRate">Interest rate</label>
            <!-- <span class="ip-hint"><span class="ip-hint__dot"></span>2-yr fixed avg: 4.85%</span> -->
          </div>
          <div class="ip-input">
            <input
              type="text"
              id="mortgageInterestRate"
              class="ip-input__field"
              autocomplete="off"
              placeholder="e.g. 5.2"
              [(ngModel)]="mortgageInterestRate"
              (keyup)="mortgageInterestRate=validation.appendPercent($event,mortgageInterestRate)"
              (keypress)="validation.DesimalOnly($event,mortgageInterestRate)">
            <span class="ip-input__suffix">% p.a.</span>
          </div>
        </div>

        <!-- Loan Tenure -->
        <div class="ip-field">
          <label class="ip-field__label">Loan tenure</label>
          <div class="ip-chip-row">
            <button class="ip-chip" [class.is-active]="mortgageTenure=='5'"  (click)="mortgageTenure='5'"  type="button">5 yrs</button>
            <button class="ip-chip" [class.is-active]="mortgageTenure=='10'" (click)="mortgageTenure='10'" type="button">10 yrs</button>
            <button class="ip-chip" [class.is-active]="mortgageTenure=='15'" (click)="mortgageTenure='15'" type="button">15 yrs</button>
            <button class="ip-chip" [class.is-active]="mortgageTenure=='20'" (click)="mortgageTenure='20'" type="button">20 yrs</button>
            <button class="ip-chip" [class.is-active]="mortgageTenure=='25'" (click)="mortgageTenure='25'" type="button">25 yrs</button>
          </div>
        </div>

        <!-- Mortgage Type -->
        <div class="ip-field">
          <label class="ip-field__label">Mortgage type</label>
          <div class="ip-segmented">
            <button class="ip-segmented__option" [class.is-active]="mortgageType=='1'" (click)="mortgageType='1'" type="button">Interest Only</button>
            <button class="ip-segmented__option" [class.is-active]="mortgageType=='2'" (click)="mortgageType='2'" type="button">Repayment</button>
          </div>
        </div>

      </div><!-- /mortgage details -->

    </div><!-- /ip-form-body -->

    <div class="ip-form-actions">
      <button class="ip-btn ip-btn--ghost" type="button" [routerLink]="['/step1']">
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
          <line x1="19" y1="12" x2="5" y2="12"></line><polyline points="12 19 5 12 12 5"></polyline>
        </svg>
        Back
      </button>
      <button class="ip-btn ip-btn--primary" type="button" (click)="next()">
        Continue
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
          <line x1="5" y1="12" x2="19" y2="12"></line><polyline points="12 5 19 12 12 19"></polyline>
        </svg>
      </button>
    </div>
  </div><!-- /formCol -->

  <!-- ── RAIL ── -->
  <div rail>
    <div class="ip-rail-summary">
      <div class="ip-rail-summary__head">
        <div class="ip-rail-summary__loc">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path><circle cx="12" cy="10" r="3"></circle>
          </svg>
          <span class="ip-rail-summary__loc-name">{{ City || 'United Kingdom' }}</span>
        </div>
        <div class="ip-rail-summary__buyer-tag" [class.is-uk]="calcData?.ForeignBuyer!=='1'">
          {{ calcData?.ForeignBuyer === '1' ? 'Foreign Buyer' : 'UK Resident' }}
        </div>
      </div>

      <div class="ip-rail-summary__body">
        <div class="ip-rs-section">
          <div class="ip-rs-section__head">
            <span class="ip-rs-section__label">Property &amp; Financing</span>
          </div>
          <div class="ip-rs-row" *ngIf="PropertyValue">
            <span class="ip-rs-row__key">Property value</span>
            <span class="ip-rs-row__val">£{{ PropertyValue }}</span>
          </div>
          <div class="ip-rs-row" *ngIf="optmortgage=='1'">
            <span class="ip-rs-row__key">LTV</span>
            <span class="ip-rs-row__val">{{ loanAmount }}%</span>
          </div>
          <div class="ip-rs-row" *ngIf="optmortgage=='1'">
            <span class="ip-rs-row__key">Loan amount</span>
            <span class="ip-rs-row__val">{{ loanAmountDisplay }}</span>
          </div>
          <div class="ip-rs-row" *ngIf="optmortgage=='1' && mortgageInterestRate">
            <span class="ip-rs-row__key">Interest rate</span>
            <span class="ip-rs-row__val">{{ mortgageInterestRate }}</span>
          </div>
          <div class="ip-rs-row" *ngIf="optmortgage=='0'">
            <span class="ip-rs-row__key">Financing</span>
            <span class="ip-rs-row__val">All-cash</span>
          </div>
        </div>

        <div class="ip-rs-section">
          <div class="ip-rs-section__head">
            <span class="ip-rs-section__label">Currency &amp; Growth</span>
          </div>
          <div class="ip-rs-row ip-rs-row--placeholder">
            <span class="ip-rs-row__key">Currency &amp; period</span>
            <span class="ip-rs-row__val">Step 3</span>
          </div>
        </div>
      </div>

      <div class="ip-rail-summary__outlay">
        <div class="ip-rail-summary__outlay-label">Indicative deposit</div>
        <div class="ip-rail-summary__outlay-value">{{ depositDisplay }}</div>
        <div class="ip-rail-summary__outlay-meta">Stamp duty &amp; costs added in Step 4</div>
      </div>
    </div>
  </div><!-- /rail -->

</app-ip-shell>
